var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProjects = function SvgProjects(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B4CFFF",
    fillRule: "evenodd",
    d: "M17 17H7a2 2 0 0 0-2 2v45a2 2 0 0 0 2 2h44a2 2 0 0 0 2-2V53H19a2 2 0 0 1-2-2z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C9BF1",
    fillRule: "evenodd",
    d: "M17 11h-4a2 2 0 0 0-2 2v45a2 2 0 0 0 2 2h44a2 2 0 0 0 2-2v-5H19a2 2 0 0 1-2-2z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    fillRule: "evenodd",
    d: "M17 6a2 2 0 0 1 2-2h45a2 2 0 0 1 2 2v45a2 2 0 0 1-2 2H19a2 2 0 0 1-2-2zm4 4a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H23a2 2 0 0 1-2-2zm23-2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zm1 17a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H47a2 2 0 0 1-2-2zm-22-2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zm13 16a2 2 0 0 1 2-2h22a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H38a2 2 0 0 1-2-2zm-13-2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6C9BF1",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M26 43h2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFD2A8",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M26 14h8.14"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6C9BF1",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M47 14h10"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF9D43",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M50 29h7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2F68D1",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M26 29h11"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B4CFFF",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M41 43h16"
  })));
};
export default SvgProjects;